import { render, staticRenderFns } from "./RiskResult.vue?vue&type=template&id=35b93794&scoped=true&"
import script from "./RiskResult.vue?vue&type=script&lang=js&"
export * from "./RiskResult.vue?vue&type=script&lang=js&"
import style0 from "./RiskResult.vue?vue&type=style&index=0&id=35b93794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b93794",
  null
  
)

export default component.exports